var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('sale-print-buttons',{ref:"print_buttons",attrs:{"sale":_vm.sale}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }